export default function MainController($scope, $rootScope, $state, localStorageService, ClassRoomService, OauthService, $window) {
  var self = this;

  $scope.arrow=false;
  var screenWidth = window.innerWidth;

  $rootScope.showSideMenu= true;
  $scope.showClassRooms = false;

  var classRoomPromise

  this.getAllClassRooms = function(){
    classRoomPromise = ClassRoomService.getAllClassRooms().then(function(resp){
      $scope.allClassRooms = resp.data;
    });
  };

  $scope.$on('classRoomRefresh', function(ev, data){
    self.getAllClassRooms();
  })

  var i=2;
  $scope.openNav = function() {
    $scope.arrow = !$scope.arrow;
  	if(i%2 === 0){
  	  document.getElementById("mySidenav").style.width = "250px";
      if(screenWidth > 1196){
        document.getElementById("main").style.marginLeft = "250px";
      }
  	  $scope.showUserOptions = false;
  	}
  	else{
  	  document.getElementById("mySidenav").style.width = "0";
      if(screenWidth > 1196){
        document.getElementById("main").style.marginLeft = "0";
      }
        $scope.showUserOptions = false;
  	}
  	i++;
  };

  self.userInfo = localStorageService.get('userInfo') || "";

  $scope.$on('userInfo', function(ev, data){
    self.userInfo = data;
    console.log(self.userInfo);
  });  

  $scope.openUserOptions = function(){
  	$scope.showUserOptions = !$scope.showUserOptions;
  };

  $scope.goToClassRooms = function(){
    // $state.go('olr.mainfe.class');
    $scope.showClassRooms = !$scope.showClassRooms;
  };

  $scope.goToIndvClass = function(classObj){
    // $state.go('olr.mainfe.class');
    $state.go('olr.mainfe.indvclass', {classRoomName: classObj.classRoomName, subName:classObj.subjectName, cId: classObj.classRoomId });
    if(screenWidth < 1196){
      $scope.arrow = true;
      $scope.openNav();
    }
  };

  $scope.goToAttendance = function(){
    $state.go('olr.mainfe.attendance');
    $scope.arrow = true;
    $scope.openNav();
  };

  $scope.goToAssignment = function(){
    $state.go('olr.mainfe.homework');
    if(screenWidth < 1196){
      $scope.arrow = true;
      $scope.openNav();
    }
  };

  $scope.goToAnnouncement = function(){
    $state.go('olr.mainfe.announcement');
    if(screenWidth < 1196){
      $scope.arrow = true;
      $scope.openNav();
    }
  };

  $scope.goToReports = function(){
    $state.go('olr.mainfe.reports');
      $scope.arrow = true;
      $scope.openNav();
  };

  $scope.goToAdmin = function(){
    $state.go('olr.mainfe.admin');
    if(screenWidth < 1196){
      $scope.arrow = true;
      $scope.openNav();
    }
  };

  $scope.goToDashboard = function(){
    $state.go('olr.mainfe.dashboard');
    if(screenWidth < 1196){
      $scope.arrow = true;
      $scope.openNav();
    }
  };

  $scope.signout = function(){
    localStorageService.clearAll();
    $window.location.href = OauthService.redirectToGoogle();
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe/MainController.js
 **/